import { UrlConstants } from "../url.constants";
export class ApiTemplateConstants {
    static URL = UrlConstants.API_V2 + "Template";
    static FUNCTION_DELETE_MULTIPLE_TEMPLATES = "DeleteMultipleTemplates";
    static FUNCTION_DELETE_ALL_TEMPLATES = "DeleteAllTemplates";
    static FUNCTION_GET_TEMPLATE_ATTACHMENTS = "GetTemplateAttachments";
    static FUNCTION_GET_TEMPLATE_ATTACHMENT = "GetTemplateAttachment";
    static FUNCTION_UPLOAD_TEMPLATE_ATTACHMENTS = "UploadTemplateAttachment";
    static FUNCTION_DELETE_TEMPLATE_ATTACHMENT = "DeleteTemplateAttachment";
}
